import { Component} from '@angular/core';
import { User, ConfigService, LottoBetpanelService, SessionService, SportBetPanelService, SharedService, AppType } from 'baseline-lib';
import { NavController, ModalController } from 'ionic-angular';
import { Global } from '../../../global/global';
import { WebviewpagesPage } from '../../shared/webviewpages/webviewpages';
import { CustomToast } from '../../shared/services/custom-toast';
import { TranslateService } from '@ngx-translate/core';
import { HostListener } from '@angular/core'


/**
 * Generated class for the ProfileComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'profile',
  templateUrl: 'profile.html',
  
})
export class ProfileComponent {
 
  userName: string;
  httplink: string;
  myprofile: any[];
  retailer: any[];
  is_expanded: boolean = false;
  profiletoggle: boolean = false;
  title: String;
  interval: any;
  user:any;
  retailers:any;
  menudata:any;

  @HostListener('window:message', ['$event'])
  andClickEvent(event: any) {
    console.log("message-->",event);
    if(event.origin == this._configService.getOPASUrl().split('/opas')[0] && event.data == "logout"){
    this.logOut();
  }

    
  }
  constructor(public navCtrl: NavController, public globalData: Global,
    public _configService: ConfigService, public modalCtrl: ModalController,
    public translate: TranslateService,
    public _lottoBetpanelService: LottoBetpanelService, public _sportsBetpanelServices: SportBetPanelService,
    public toast: CustomToast, public _sharedService: SharedService,
    public _sessionService: SessionService) {

    console.log('Hello ProfileComponent Component');

  }

  ngOnInit() {
    console.log(AppType);
    
   this.user=AppType.user;
   this.retailers=AppType.retailer;
    
    if (localStorage.getItem("authUser") !== null && localStorage.getItem("authUser") !== "") {
      this.globalData.authUser = <User>JSON.parse(localStorage.getItem("authUser"));
    }
    // this.myprofile = ["Change Password","KYC","Deposit","Add Cash","Transaction Report","Withdrawal Report","Payment Gateway Report"];
    this.myprofile = ["Change Password", "Wallet Balance", "Transaction Report", "Withdrawal Report", "History"];
    this.retailer =["Change Password","Game Sales Report","Balance Report","Pay","Cancel","History"];
    this.userName = this.globalData.authUser.name;

  }
 
  


  startTimer() {
    // this.play = true;
    this.interval = setInterval(() => {
      //console.log(window.location.href);
      if (window.location.href.indexOf("logout") > -1) {
        this.logOut();
        window.location.href = window.location.href.substring(0, window.location.href.indexOf("#"));
        clearInterval(this.interval);
      }
    }, 1000)
  }


  profileback() {
    this.profiletoggle = false;
  }

  open_profile_page() {
    this.httplink = this._configService.getOPASUrl().concat("myProfile/" + this.globalData.authUser.refToken + "/en");
    console.log(this.httplink);
    this.title = "My Profile"
    this.profiletoggle = true;
    this.menudata="user";
  }

  onclick_menu(menu: String, position: any) {
    this.title = menu;
    if(menu == "History")
    {
      this.menudata = "History";
    }
    else
    {
      if (menu == "Change Password") {
        this.httplink = this._configService.getOPASUrl().concat("changePassword/" + this.globalData.authUser.refToken + "/" + this._sharedService.selectedLanguage);
        this.startTimer();
      } else if (menu == "KYC") {
        this.httplink = this._configService.getOPASUrl().concat("kyc/" + this.globalData.authUser.refToken + "/" + this._sharedService.selectedLanguage);
      } else if (menu == "Deposit" || menu == "Wallet Balance") {
        this.httplink = this._configService.getOPASUrl().concat("wallet/" + this.globalData.authUser.refToken + "/" + this._sharedService.selectedLanguage);
      } else if (menu == "Add Cash") {
        this.httplink = this._configService.getOPASUrl().concat("payment/" + this.globalData.authUser.refToken + "/" + this._sharedService.selectedLanguage);
      } else if (menu == "Transaction Report") {
        this.httplink = this._configService.getOPASUrl().concat("playerTransaction/" + this.globalData.authUser.refToken + "/" + this._sharedService.selectedLanguage);
      } else if (menu == "Withdrawal Report") {
        this.httplink = this._configService.getOPASUrl().concat("withdrawReport/" + this.globalData.authUser.refToken + "/" + this._sharedService.selectedLanguage);
      } else if (menu == "Payment Gateway Report") {
        this.httplink = this._configService.getOPASUrl().concat("playerGatewayReport/" + this.globalData.authUser.refToken + "/" + this._sharedService.selectedLanguage);
      }
      this.menudata="user";
    }
    this.profiletoggle = true;
  }

  onclick_menuretailer(menu: String, position: any){
    console.log(menu);
    console.log(position);
    this.profiletoggle = true;
    
    // if(menu == "Change Password"){
    //   this.menudata=menu;
    // }
    // else if(menu == "Game Sales Report"){
    //   this.menudata=menu;
    // }
    // else if(menu == "Cancel"){
    //   this.menudata=menu;
    // }
    // else if(menu == "Pay"){
    //   this.menudata=menu;
    // }
    // else if(menu == "Remit"){
    //   this.menudata=menu;
    // }
    // else if(menu == "Balance Report"){
    //   this.menudata=menu;
    // }
    // else if(menu == "History"){
    //   this.menudata=menu;
    // }
    
    this.menudata=menu;
    this.title = menu;
    console.log(this.menudata);
    
  }

  open_submenu() {
    if (this.is_expanded) {
      this.is_expanded = false;
    } else {
      this.is_expanded = true;
    }
  }

  openDepositPage() {
    this.httplink = this._configService.getOPASUrl().concat("wallet/" + this.globalData.authUser.refToken);
    let profileModal = this.modalCtrl.create(WebviewpagesPage, { url: this.httplink });
    profileModal.present();
  }

  logOut() {
    localStorage.clear();
    this.globalData.selectedMenu = "home";
    this.globalData.isLoggedIn = false;
    this.globalData.authUser = new User();
    this._sessionService.authUser = undefined;
    this._lottoBetpanelService.clearallBetPanels();
    this._sportsBetpanelServices.clearallBetPanels();
    this.translate.get('You have been logged out successfully!').subscribe(
      value => {
        this.toast.showSuccess(value);
      });

    this._sharedService.loginSubject.next(false);
    if (!this._configService.isplayerLogin())
      this.navCtrl.setRoot(this.navCtrl.getActive().component);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

}



// WEBPACK FOOTER //
// ./src/app/profile/profile/profile.ts